import createActionType from "../utils/createActionType";

export const MODULE = "timezones";

export const SET_TIMEZONES = createActionType(MODULE, "setTImezones");
